import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { SelectField, TextField } from "@/components/control/kit";
import { V3Page, V3Aside, V3Actions, useRun, ErrorLine } from "@/components/control/v3";

export const TASK_VIEW_LABELS = {
  country: { all: "Alle Länder", CH: "Schweiz", DE: "Deutschland", AT: "Österreich" },
  scope: { open: "Offen", mine: "Mir zugewiesen", done: "Von mir erledigt" },
  visibility: { me: "Nur ich", team: "Team mit gleicher Rolle" },
};
const opts = (map) => Object.entries(map).map(([value, label]) => ({ value, label }));

// C31: save task filters as an own (or same-role team) work view.
export default function SaveView() {
  const navigate = useNavigate();
  const [v, setV] = useState({ name: "", country: "all", scope: "open", visibility: "me" });
  const { busy, error, run } = useRun();
  const set = (k) => (val) => setV((s) => ({ ...s, [k]: val }));
  const save = async () => {
    const body = { name: v.name, area: "aufgaben", visibility: v.visibility, filters: { country: v.country, scope: v.scope } };
    if (await run(() => api.post("/saved-views", body), "Arbeitsansicht gespeichert.")) navigate("/aufgaben");
  };
  return (
    <V3Page crumb="Meine Aufgaben" title="Arbeitsansicht speichern" subtitle="Speichere Filter für deine eigene Arbeitsansicht."
      aside={<V3Aside subjectTitle="Ausgewählter Vorgang" subject={v.name || "Noch nicht eingegeben"}
        note="Gespeichert werden nur Filter. «Team» teilt die Ansicht mit Konten derselben Rolle; Rechte ändern sich dadurch nicht." />} testId="save-view-page">
      <TextField id="view-name" label="Name" value={v.name} onChange={set("name")} testId="view-name" />
      <SelectField id="view-country" label="Land" value={v.country} onChange={set("country")} options={opts(TASK_VIEW_LABELS.country)} testId="view-country" />
      <SelectField id="view-scope" label="Status" value={v.scope} onChange={set("scope")} options={opts(TASK_VIEW_LABELS.scope)} testId="view-scope" />
      <SelectField id="view-visibility" label="Sichtbarkeit" value={v.visibility} onChange={set("visibility")} options={opts(TASK_VIEW_LABELS.visibility)} testId="view-visibility" />
      <ErrorLine error={error} testId="view-error" />
      <V3Actions primary="Ansicht speichern" onPrimary={save} busy={busy} primaryDisabled={!v.name.trim()} onSecondary={() => navigate("/aufgaben")} testId="save-view" />
    </V3Page>
  );
}
